var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurriculum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.35379 4.50146C8.39876 4.96129 7.49679 5.40343 6.59482 5.81904C6.25879 5.97821 5.90508 6.11086 5.55137 6.21697C5.15344 6.33193 4.75551 6.23466 4.38411 6.06664C3.33181 5.57144 2.28836 5.0674 1.23606 4.5722C0.643591 4.28923 0.316406 3.82056 0.316406 3.18388C0.316406 2.51182 0.678963 2.05199 1.28028 1.76902C2.35026 1.27382 3.40256 0.760938 4.47254 0.265739C5.01195 0.0181396 5.56905 0.053511 6.09962 0.309953C7.15192 0.805152 8.20422 1.30919 9.24767 1.81324C9.8313 2.09621 10.132 2.58256 10.1408 3.22809C10.1496 4.7579 10.1496 6.29656 10.1408 7.82637C10.1408 8.12702 9.97278 8.32157 9.73403 8.32157C9.49527 8.32157 9.34494 8.13587 9.3361 7.81752C9.3361 6.82713 9.3361 5.82789 9.3361 4.83749C9.35379 4.74022 9.35379 4.65179 9.35379 4.50146Z",
    fill: "#9E9BA9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.95109 5.84766C2.62314 6.166 3.25983 6.46665 3.88767 6.76731C4.78964 7.20061 5.68277 7.20945 6.58473 6.75847C7.21258 6.45781 7.84042 6.166 8.50363 5.8565C8.49479 6.61698 8.60974 7.35978 8.18529 8.02299C7.78736 8.65084 7.18605 8.90728 6.50515 9.03108C5.48822 9.20794 4.4713 9.19909 3.47206 8.91612C2.58777 8.66852 2.00414 7.93457 1.95993 7.01491C1.9334 6.64351 1.95109 6.27211 1.95109 5.84766Z",
    fill: "#9E9BA9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurriculum);
export default __webpack_public_path__ + "static/media/curriculum.8be60303c30c7eb5a00934ea033d1c56.svg";
export { ForwardRef as ReactComponent };